<odx-card
  [menuIcon]="'more'"
  [variant]="'launch-tile'"
  odxLayout="flex"
  class="configured-item"
  [ngClass]="{
    discontinued: isDiscontinued$ | async,
    incomplete: isIncompleteConfiguration$ | async,
  }"
  (click)="onAdd($event)"
  draggable="true"
  (dragstart)="onDragStart($event)"
>
  <odx-avatar [ngClass]="'avatar'">
    <app-product-image
      [productId]="productImageId"
      [imageUrl]="imageUrl"
      [fallbackImageUrl]="fallbackImageUrl"
      [iconSize]="'56px'"
    ></app-product-image>
  </odx-avatar>
  <div class="title" [odxTooltip]="(localizedName$ | async) ?? ''" odxTooltipSize="medium">
    {{ localizedName$ | async }}
  </div>
  <odx-launch-card-subtitle class="configured-item-subtitle">
    @if (subtitle$ | async; as subtitle) {
      <p class="odx-text--small" [odxTooltip]="subtitle" odxTooltipSize="medium">
        {{ subtitle }}
      </p>
    }
    @if (substanceSubtitle) {
      <p class="odx-text--xsmall" [odxTooltip]="substanceSubtitle" odxTooltipSize="medium">
        {{ substanceSubtitle }}
      </p>
    }
    <p class="odx-text--xsmall" i18n="@@floorplan.menu.timesPlaced">{{ placedProductCount }}x platziert</p>
    @if (productConfiguration.additionalProductListQuantity > 0) {
      <p class="odx-text--xsmall" i18n="@@floorplan.menu.timesAddedToProductList">
        {{ productConfiguration.additionalProductListQuantity }}x zusätzlich zur Produktliste hinzugefügt
      </p>
    }
    @if (placedProductCount > 0 && productConfiguration.additionalProductListQuantity > 0) {
      <p class="odx-text--xsmall" i18n="@@floorplan.menu.totalInProductList">
        {{ productConfiguration.totalProductListQuantity }}x insgesamt
      </p>
    }
  </odx-launch-card-subtitle>
  @if (isDiscontinued$ | async) {
    <odx-card-footer>
      <odx-inline-message variant="warning" i18n="@@floorplan.menu.warningDiscontinued"
        >Enthält abgekündigte Komponenten</odx-inline-message
      >
    </odx-card-footer>
  }
  @if (isIncompleteConfiguration$ | async) {
    <odx-card-footer>
      <odx-inline-message variant="warning" i18n="@@floorplan.menu.warningIncompleteConfig"
        >Unvollständige Konfiguration</odx-inline-message
      >
    </odx-card-footer>
  }
  <odx-menu>
    <button odxButton class="odx-button" type="button" (click)="onShowAttachments($event)" data-testid="btn.showAttachments">
      <odx-icon name="document" size="medium"></odx-icon
      ><span i18n="@@productList.additionalProducts.showConfiguration">Konfiguration anzeigen</span>
    </button>
    <button odxButton class="odx-button" type="button" (click)="onEditConfig($event)" data-testid="btn.edit">
      <odx-icon name="edit" size="medium"></odx-icon><span i18n="@@global.edit">Bearbeiten</span>
    </button>
    @if (canEditProductList()) {
      <button odxButton class="odx-button" type="button" (click)="onAddToProductList($event)" data-testid="btn.addToProductList">
        <odx-icon name="plus" size="medium"></odx-icon
        ><span i18n="@@floorplan.menu.addToProductList">Zur Produktliste hinzufügen</span>
      </button>
    }
    <button odxButton class="odx-button" type="button" (click)="onDeleteConfig($event)" data-testid="btn.delete">
      <odx-icon name="delete" size="medium"></odx-icon><span i18n="@@global.delete">Löschen</span>
    </button>
  </odx-menu>
</odx-card>
